// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"776aec78","496":"bad8c7ae","774":"ef893b55","827":"5a8633f1"}[chunkId] + ".chunk.js";
};